module.exports = __webpack_public_path__ + "img/cloud-raining-04.23b17361.svg";